<template>
    <v-card class="pa-3 ma-md-3">
        <loader v-if="isloading"></loader>

        <v-toolbar flat color="#1d2735" dark>
            <v-icon class="white--text" style="font-size: 45px"
                >mdi-account-supervisor-circle</v-icon
            >
            <pre><v-toolbar-title><h2>Lista de seguimiento</h2></v-toolbar-title></pre>
        </v-toolbar>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-seguimiento` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-account-plus-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Nuevo seguimiento</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/calendario-seguimiento` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="primary darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-calendar</v-icon>
                </v-btn>
            </template>
            <span>Calendario de seguimientos</span>
        </v-tooltip>

        <v-row>
            <v-col cols="12" md="8">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>
            <v-col cols="12" md="4">
                <v-text-field
                    outlined
                    readonly
                    v-model="total_cliente"
                    label="Total"
                >
                </v-text-field>
            </v-col>
        </v-row>

        <v-data-table
            dense
            :headers="headers"
            :items="Seguimientos"
            :search="filtros_prueba.search"
            :items-per-page="15"
            item-key="id"
            class="elevation-1"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            :server-items-length="total_cliente"
            @update:items-per-page="ChangeSize"
            @pagination="ChangePage"
        >
            <template v-slot:item.fecha="{ item }">
                <span>{{ item.fecha | format_date }}</span>
            </template>
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{
                        path: `/guardar-cliente?id=${item.id_cliente}&tab=seguimiento`,
                    }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="Ver"
                        >mdi-eye</v-icon
                    >
                </router-link>
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>
        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteUser()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>
<script>
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import { debounce } from "../../../helpers";

export default {
    components: {
        FilterComponentVue,
    },
    data() {
        return {
            total_cliente: 0,
            filtros_prueba: {
                search: "",
            },
            filter_headers: [
                {
                    title: "Agente",
                    type: "select",
                    active: false,
                    model: "agente",
                    item_text: "nombre",
                    item_value: "id",
                },
                {
                    title: "Estado",
                    type: "select",
                    active: false,
                    model: "estado",
                    item_text: "nombre",
                    item_value: "id",
                },
            ],
            search: "",
            loading: false,
            headers: [
                {
                    text: "Cliente",
                    // value: "cliente.nombre_comercial",
                    value: "cliente",
                    sortable: true,
                },
                {
                    text: "Estado",
                    // value: "cliente.estado.nombre",
                    value: "estado",
                    sortable: true,
                },
                {
                    text: "Observaciones",
                    value: "observacion",
                    sortable: true,
                },
                {
                    text: "Comercial",
                    // value: "cliente.agentes_str",
                    value: "agente",
                    sortable: true,
                },
                { text: "Fecha", value: "fecha", sortable: true },
                { text: "Acciones", value: "action", sortable: false },
            ],
            Seguimientos: [],
            selectedItem: 0,
            dialog: false,
            cantidad: 15,
            page: 1,
            sortBy: [],
            sortDesc: [],
        };
    },
    created() {
        this.getEstadosPotencial();
        this.getSeguimientos();
        this.getAgentes();
        if (this.$store.getters.getfiltros["seguimientos"] != null) {
            this.filtros_prueba =
                this.$store.getters.getfiltros["seguimientos"];
        }
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: debounce(function (val) {
                this.$store.dispatch("saveFiltrosSeguimiento", val);
                this.getSeguimientos();
            }, 500),
        },
        sortBy: {
            handler: debounce(function () {
                this.getSeguimientos();
            }, 100),
            deep: true,
        },
        sortDesc: {
            handler: debounce(function () {
                this.getSeguimientos();
            }, 100),
            deep: true,
        },
    },
    methods: {
        getEstadosPotencial() {
            axios.get(`api/get-estados-potencial`).then(
                (res) => {
                    this.filter_headers[1].items = res.data;
                },
                (res) => {}
            );
        },
        getAgentes() {
            axios.get(`api/get-agentes`).then(
                (res) => {
                    this.filter_headers[0].items = [
                        ...[{ id: 0, nombre: "Sin Asignar" }],
                        ...res.data.Agentes,
                    ];
                },
                (res) => {}
            );
        },
        ChangeSize(event) {
            this.cantidad = event;
            this.getSeguimientos();
            //console.log(`evento: ${event}`);
        },
        ChangePage(event) {
            this.page = event.page;
            this.getSeguimientos();
            //console.log(event);
        },
        getSeguimientos() {
            if (this.loading) return;
            this.loading = true;
            /*let filtros = this.filterString;

            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&search=${this.filtros_prueba.search}`;
            }
            if (this.filtros_prueba.agente)
                filtros +=
                    this.filtros_prueba.agente.value != null
                        ? `&id_agente=${this.filtros_prueba.agente.value}`
                        : "";*/

            axios
                /*.get(
                    `api/get-seguimientos?page=${this.page}&amount=${this.cantidad}${filtros}`
                )*/
                .get(`api/get-seguimientos`, {
                    params: {
                        page: this.page,
                        amount: this.cantidad,
                        search: this.filtros_prueba.search,
                        id_agente: this.filtros_prueba.agente?.value,
                        estado: this.filtros_prueba.estado?.value,
                        sort_by: this.sortBy.join(","),
                        sort_desc: this.sortDesc.join(","),
                    },
                })
                .then(
                    (res) => {
                        this.loading = false;

                        this.Seguimientos = res.data.data;
                        this.total_cliente = res.data.total;
                    },
                    (err) => {
                        this.loading = false;

                        this.$custom_error(
                            "Error consultando los seguimientos"
                        );
                    }
                );
        },
        openModal(item) {
            this.selectedItem = this.Seguimientos.indexOf(item);
            this.dialog = true;
        },
        deleteUser() {
            axios
                .post("api/delete-seguimiento", {
                    id: this.Seguimientos[this.selectedItem].id,
                })
                .then(
                    (res) => {
                        this.$toast.sucs("Seguimiento eliminado con éxtio");
                        this.dialog = false;
                        this.getSeguimientos();
                    },
                    (err) => {
                        this.$custom_error("Error eliminando el seguimiento");
                    }
                );
        },
    },
    computed: {
        filterString() {
            let filtros = "";
            if (
                this.filtros_prueba.search != null &&
                this.filtros_prueba.search != ""
            ) {
                filtros += `&busqueda=${this.filtros_prueba.search}`;
            }
            this.filter_headers.forEach((head) => {
                if (this.filtros_prueba[head.model]) {
                    if (head.type == "date") {
                        if (
                            this.filtros_prueba[head.model].start != "" &&
                            this.filtros_prueba[head.model].start != null
                        ) {
                            filtros += `&${head.model}_desde=${
                                this.filtros_prueba[head.model].start
                            }`;
                        }
                        if (
                            this.filtros_prueba[head.model].end != "" &&
                            this.filtros_prueba[head.model].end != null
                        ) {
                            filtros += `&${head.model}_hasta=${
                                this.filtros_prueba[head.model].end
                            }`;
                        }
                    } else {
                        if (
                            (this.filtros_prueba[head.model].value != "" &&
                                this.filtros_prueba[head.model].value !=
                                    null) ||
                            (this.filtros_prueba[head.model].nombre != "" &&
                                this.filtros_prueba[head.model].nombre != null)
                        ) {
                            filtros += `&${head.model}=${
                                this.filtros_prueba[head.model].value
                            }`;
                        }
                    }
                }
            });
            return filtros;
        },
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
